import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installOfflineSync } from "@/lib/offlineQueue";

import { devWarn } from "./lib/devLog";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Install PWA service worker + offline attendance sync
installOfflineSync();
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((reg) => {
        // If an updated worker is already waiting when the page loads,
        // silently activate it — no user click required. See sw.js install
        // handler comment for the rationale.
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }

        // Detect a new SW being installed while the page is open.
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            // Once installed, silently take over. The controllerchange
            // listener below then triggers a one-time reload.
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              installing.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });

        // Cheap byte-diff check on sw.js — triggers `updatefound` if changed.
        reg.update().catch(() => {});
      })
      .catch((err) => {
        devWarn("SW registration failed:", err);
      });

    // When the newly-activated SW takes over, reload once so the freshly-
    // cached shell + current JS bundle are what the tab actually runs.
    let reloadedForNewSW = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloadedForNewSW) return;
      reloadedForNewSW = true;
      window.location.reload();
    });
  });
}
